import { Text, Link, Img } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import { QuestWithConfig, QuestFrequency } from 'state/vvsgotchi/models/quest'

import { ExpTable, ExpTHead, ExpTr } from '../styles'

export const VariableExp = ({ quest }: { quest: QuestWithConfig }) => {
  const { t } = useTranslation()

  return (
    <>
      <Text color="black" fontWeight="600" mb="8px">
        {t('Earn variable EXP')}
      </Text>
      <Text color="darkGrey" mb={2}>
        {quest.frequency === QuestFrequency.UNLIMITED &&
          t(
            'You can complete this quest unlimited times during the day, but with diminishing amounts of EXP earned. The full EXP amount will be reset daily at 00:00 UTC',
          )}
      </Text>
      <Text fontSize="13px" color="darkGrey">
        {t('You may earn more or less than this amount depending on your team’s health meter. ')}
        <Link
          inline
          underline="always"
          href="https://docs.vvs.finance/product-guides/vvs-gotchi/quest-page"
          target="_blank"
          rel="noreferer noopener"
        >
          {t('Learn more')}
        </Link>
      </Text>

      <ExpTable>
        <ExpTHead>
          <tr>
            <th>
              <Text color="darkGrey" fontSize="13px">
                {t('Cumulative Amount')}
              </Text>
              <Text color="darkGrey" fontSize="13px">
                {t('(in 1 day)')}
              </Text>
            </th>
            <td>
              <Text color="darkGrey" fontSize="13px">
                {t('EXP')}
              </Text>
              <Text color="darkGrey" fontSize="13px">
                {t('(per USD 1)')}
              </Text>
            </td>
          </tr>
        </ExpTHead>
        <tbody>
          {quest.variableExpRules.map(({ cumulativeUsd, expPerUsd }, index) => (
            <ExpTr key={cumulativeUsd.from}>
              <td>
                <Text color="darkGrey" bold>
                  {cumulativeUsd.to
                    ? index === 0
                      ? t('First USD %from% - %to%', cumulativeUsd)
                      : t('USD > %from% - %to%', cumulativeUsd)
                    : t('USD > %from%', cumulativeUsd)}
                </Text>
              </td>
              <td>
                <Img src="/images/vvsGotchi/star.png" height="17.25px" />
                <Text ml="6px" color="darkGrey" display="inline-block" bold>
                  +{expPerUsd}
                </Text>
              </td>
            </ExpTr>
          ))}
        </tbody>
      </ExpTable>
    </>
  )
}
